<div class="modal-window__header">
  <div class="modal-window__title">{{ "service.settings" | translate }}</div>
  <a (click)="modalService.close()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="updateServiceSchedule()"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label class="c-form-label">{{ "service.nextservice" | translate }}</label>
    <div class="c-input-group">
      <datepicker-input
        [inputDate]="service.nextDate"
        (dateChange)="service.nextDate = $event">
      </datepicker-input>
    </div>
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <div class="o-grid">
      <div class="o-grid__item col-12 col-sm-6">
        <label class="c-form-label">{{ "service.interval" | translate }}</label>
        <mat-select
          #interval="ngModel"
          [(ngModel)]="service.interval"
          name="servInterval"
          id="servInterval"
          class="c-user-menu__select c-select c-select--lg"
          [class.is-invalid]="interval.touched && interval.invalid"
          (ngModelChange)="setServiceFrequencyList()"
          required>
          <mat-option
            *ngFor="let interval of intervals"
            [value]="interval.id">
            {{ interval.localizedTitle | translate }}
          </mat-option>
        </mat-select>
        <div
          *ngIf="interval.touched && interval.invalid"
          class="c-form-alert">
          {{ "service.intervalrequirederror" | translate }}
        </div>
      </div>

      <div class="o-grid__item col-12 col-sm-6">
        <label class="c-form-label">{{ "service.frequency" | translate }}</label>
        <mat-select
          #frequency="ngModel"
          [(ngModel)]="service.frequency"
          name="servFrequency"
          id="servFrequency"
          class="c-user-menu__select c-select c-select--lg"
          [class.is-invalid]="frequency.touched && frequency.invalid"
          (ngModelChange)="refreshNextScheduleDate()"
          required>
          <mat-option
            *ngFor="let item of frequencyList"
            [value]="item"
            >{{ item }}</mat-option
          >
        </mat-select>
        <div
          *ngIf="frequency.touched && frequency.invalid"
          class="c-form-alert">
          {{ "service.frequencyrequirederror" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="modalService.close()">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid || !service.nextDate || isLoading">
      <app-loading-icon *ngIf="isLoading"></app-loading-icon>
      <span *ngIf="!isLoading">{{ "button.save" | translate }}</span>
    </button>
  </div>
</form>
